// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea_textarea__1Sx-W","margin":"textarea_margin__Jk74f"};